// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"489":"f924349e","515":"4f034e44","717":"a3758bcf","863":"a6f3448f"}[chunkId] + ".css";
};